import { render, staticRenderFns } from "./orientationModuleAssignmentForm.vue?vue&type=template&id=1b3512d6&scoped=true&"
import script from "./orientationModuleAssignmentForm.vue?vue&type=script&lang=js&"
export * from "./orientationModuleAssignmentForm.vue?vue&type=script&lang=js&"
import style0 from "./orientationModuleAssignmentForm.vue?vue&type=style&index=0&id=1b3512d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3512d6",
  null
  
)

export default component.exports